import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

/** Catches render errors so one broken workspace cannot blank the whole studio. */
export class ErrorBoundary extends Component<{ children: ReactNode; label?: string }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('SonicForge UI error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="rounded-xl border border-red-800 bg-red-950/50 p-4 text-sm text-red-100">
        <p className="font-semibold">{this.props.label ?? 'This section'} crashed.</p>
        <p className="mt-1 opacity-80">{this.state.error.message}</p>
        <button
          type="button"
          className="mt-3 rounded-md bg-red-700 px-3 py-1.5 font-medium hover:bg-red-600"
          onClick={() => this.setState({ error: null })}
        >
          Try again
        </button>
      </div>
    );
  }
}
